"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocaleStore = /** @class */ (function () {
    function LocaleStore(json) {
        this.localeStore = {};
        this._set(json);
    }
    LocaleStore.prototype._get = function (name) {
        return this.localeStore[name] || {};
    };
    LocaleStore.prototype._set = function (json) {
        this.localeStore = json || {};
    };
    return LocaleStore;
}());
exports.LocaleStore = LocaleStore;
//# sourceMappingURL=locale.js.map